<template>
  <div>
    <!-- <LoadingOverlay :type="type"></LoadingOverlay> -->
    <LoadingOverlay
      :customers="customers"
      :overlay="overlay"
      :value="overlay"
      v-if="$route.name != 'aboutus' && $route.name != 'feature'"
    ></LoadingOverlay>
    <v-row class="ma-0 flex-nowrap">
      <v-col class="pa-0 navigationbar" cols="2" lg="2" md="2" sm="0">
        <navigationbar :customers="customers" />
      </v-col>
      <botnavigation :customers="customers" class="pa-0 botnavigation" />
      <v-col cols="12" lg="10" md="10" sm="12" class="pa-0">
        <slider
          :customers="customers"
          v-if="$route.name == 'home' || $route.name == 'homePage'"
        />
        <gallery
          :customers="customers"
          class="mainPage"
          v-else-if="$route.name == 'gallery'"
        />
        <catalog
          :customers="customers"
          class="mainPage"
          v-else-if="$route.name == 'catalog'"
        />
        <virtualTour
          :customers="customers"
          class="mainPage"
          v-else-if="$route.name == 'virtual_tour'"
        />
        <comments
          :customers="customers"
          class="mainPage"
          v-else-if="$route.name == 'comments'"
        />
        <aboutus
          :customersAbout="customersAbout"
          class="mainPage"
          v-else-if="$route.name == 'aboutus'"
        />
        <feature
          :customers="customers"
          :customersAbout="customersAbout"
          class="mainPage"
          v-else-if="$route.name == 'feature'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoadingOverlay from "@/layouts/LoadingOverlay-temp-2.vue";
import navigationbar from "../components/navigation-bar.vue";
import botnavigation from "../components/bottom-navigation.vue";
import slider from "../components/slider.vue";
import gallery from "../components/gallery.vue";
import catalog from "../components/catalog.vue";
import virtualTour from "../components/virtual-tour.vue";
import comments from "../components/comments.vue";
import aboutus from "../components/aboutus.vue";
import feature from "../components/feature.vue";
// import { useFavicon } from "@vueuse/core";

export default {
  name: "homePage",
  data() {
    return {
      type: "scale",
      overlay: true,
      location: window.document.location.host.replace("www.", ""),
      customers: [],
      customersAbout: [],
      // customers: [],
      // tags: [],
      // title: "‌",
      // description: "",
      // keywords: [],
      // image: "",
    };
  },
  components: {
    navigationbar,
    botnavigation,
    slider,
    gallery,
    catalog,
    virtualTour,
    comments,
    aboutus,
    LoadingOverlay,
    feature,
  },
  metaInfo() {
    return {
      // title will be injected into parent titleTemplate
      title: this.title,
      titleTemplate: null,
      link: [
        {
          href: "https://namya.ir/",
          id: "canonical",
          rel: "canonical",
        },
      ],
      meta: [
        { name: "twitter:card", content: "summary" },
        {
          name: "twitter:site",
          content: "",
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description
            ? this.description.slice(0, 400)
            : this.description,
        },
        // Your twitter handle, if you have one.
        { name: "twitter:creator", content: "" },
        {
          name: "twitter:image:src",
          content: this.image,
        },

        { name: "og:card", content: "summary" },
        {
          name: "og:site",
          content: "",
        },
        {
          name: "og:title",
          content: this.title,
        },
        {
          name: "og:description",
          content: this.description
            ? this.description.slice(0, 400)
            : this.description,
        },
        // Your twitter handle, if you have one.
        { name: "og:creator", content: "" },
        {
          name: "og:image:src",
          content: "https://namya.ir/logo.jpg",
        },

        // Google / Schema.org markup:
        {
          name: "image",
          content: this.image,
        },
        { content: "text/html", charset: "utf-8" },
        {
          name: "description",
          content: this.description
            ? this.description.slice(0, 400)
            : this.description,
        },
        {
          name: "keywords",
          content: this.keywords,
        },
      ],
    };
  },
  methods: {
    async booths() {
      let response = await this.axios.get(
        "https://namya.ir/api/v1/business/48"
      );
      // console.log(self.$route.params.name);
      this.customers = response.data.data;
      this.customersAbout = response.data;
      this.title = this.customers.name;
      this.keywords = this.customers.tags.map((tags) => `${tags.name}`);
      this.description = this.customers.aboutus;
      this.tags = this.customers.tags;
      this.image = this.customers.image;
      // const icon = useFavicon();
      // icon.value = this.customers.image;
    },
    DataReceive() {
      this.$emit("ID", this.$props.customers.id);
    },
    calculateSectionOffsets() {
      let sections = document.getElementsByTagName("section");
      let length = sections.length;

      for (let i = 0; i < length; i++) {
        let sectionOffset = sections[i].offsetTop;
        this.offsets.push(sectionOffset);
      }
    },
    moveDown() {
      this.inMove = true;
      this.activeSection--;

      if (this.activeSection < 0) this.activeSection = this.offsets.length - 1;

      this.scrollToSection(this.activeSection, true);
    },
    /**
     * Move to the next section or the first section if you're on the last section
     */
    moveUp() {
      this.inMove = true;
      this.activeSection++;

      if (this.activeSection > this.offsets.length - 1) this.activeSection = 0;

      this.scrollToSection(this.activeSection, true);
    },
    /**
     * Scrolls to the passed section id if the section exists and the delay is over
     */
    scrollToSection(id, force = false) {
      if (this.inMove && !force) return false;

      this.activeSection = id;
      this.inMove = true;

      // get section and scroll into view if it exists
      let section = document.getElementsByTagName("section")[id];
      if (section) {
        document
          .getElementsByTagName("section")
          [id].scrollIntoView({ behavior: "smooth" });
      }

      setTimeout(() => {
        this.inMove = false;
      }, this.inMoveDelay);
    },
  },
  created() {
    this.booths();
  },
  mounted() {
    this.overlay = true;
    this.calculateSectionOffsets();

    window.addEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    window.addEventListener("mousewheel", this.handleMouseWheel, {
      passive: false,
    }); // Other browsers

    window.addEventListener("touchstart", this.touchStart, {
      passive: false,
    }); // mobile devices
    window.addEventListener("touchmove", this.touchMove, { passive: false }); // mobile devices
  },
  /**
   * destroyed() hook executes on page destroy and removes all registered event listeners
   */
  destroyed() {
    window.removeEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    window.removeEventListener("mousewheel", this.handleMouseWheel, {
      passive: false,
    }); // Other browsers

    window.removeEventListener("touchstart", this.touchStart); // mobile devices
    window.removeEventListener("touchmove", this.touchMove); // mobile devices
  },
};
</script>
<style>
h1,
h2,
h3,
h4,
h5,
h6,
input,
textarea {
  font-family: IRANSansX !important;
  font-weight: 900;
}
</style>
<style scoped>
body {
  overflow-y: hidden;
}

/* html {
  overflow-y: auto !important;
} */

.v-main__wrap {
  overflow-y: hidden;
  overflow-x: hidden;
}

@media only screen and (min-width: 912px) {
  .navigationbar {
    display: block !important;
  }

  .botnavigation {
    display: none !important;
  }
}

@media only screen and (max-width: 912px) {
  .navigationbar {
    display: none !important;
  }

  .botnavigation {
    display: inline-flex !important;
  }

  .mainPage {
    margin-bottom: 60px !important;
  }
}
</style>
